import ToastsContainer from '~/containers/Toasts';

type ToastFunction = (heading: string, description: string) => void;

export default function useToast() {
  const addSuccessToast: ToastFunction = (heading, description) => {
    ToastsContainer.addSuccess(heading, description);
  };

  const addErrorToast: ToastFunction = (heading, description) => {
    ToastsContainer.addError(heading, description);
  };

  const addWarningToast: ToastFunction = (heading, description) => {
    ToastsContainer.addWarning(heading, description);
  };

  const addInfoToast: ToastFunction = (heading, description) => {
    ToastsContainer.addMessage(heading, description);
  };

  return {
    addSuccessToast,
    addErrorToast,
    addWarningToast,
    addInfoToast,
  };
}
